<template>
  <loading :active="loading">
    <atom-spinner :animation-duration="1000" :size="60" :color="themeColor"></atom-spinner>
  </loading>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { AtomSpinner } from 'epic-spinners';

export default {
  components: {
    Loading,
    AtomSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    themeColor() {
      return this.$store.getters.themeColor(this.$route.params.surveyId);
    }
  }
}
</script>
